import { render, staticRenderFns } from "./RouteTimePoint.vue?vue&type=template&id=b2c0b130&"
import script from "./RouteTimePoint.vue?vue&type=script&lang=js&"
export * from "./RouteTimePoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports